<template>
  <hm-content title="查看预约列表">
    <div class="table-panel flex flex-between">
      <span class="activity-name">{{ subActivityDetails.actName }}</span>
      <div class="flex flex-between">
        <el-date-picker
            size="small"
            clearable
            class="mr10"
            v-model="date"
            ref="datepicker"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            range-separator="至"
            start-placeholder="报名开始时间"
            end-placeholder="报名结束时间"
        ></el-date-picker>
        <el-select
          clearable
          v-model="actSite"
          placeholder="选择场地"
          @change="selectAddress"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            :label="v.actSite"
            :value="v.actSite"
            v-for="(v, i) in siteList"
            :key="i"
          ></el-option>
        </el-select>
        <el-select
          :disabled="!actSite"
          clearable
          v-model="subRoundId"
          placeholder="选择场次"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            :label="v.actRound"
            :value="v.id"
            v-for="(v, i) in roundList"
            :key="i"
          ></el-option>
        </el-select>
        <el-input
          clearable
          class="mr10"
          size="small"
          v-model="keyword"
          placeholder="请输入用户名/电话"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table">
      <div class="hm-radio-group">
        <el-radio-group v-model="timeStatus" size="small" @change="switchTab">
          <el-radio-button label="all"
            >全部({{ subApplyActivity.allNum }})</el-radio-button
          >
          <el-radio-button label="applied"
            >已报名({{ subApplyActivity.appliedNum }})</el-radio-button
          >
          <el-radio-button label="completed"
            >已完成({{ subApplyActivity.completedNum }})</el-radio-button
          >
          <el-radio-button label="canceled"
            >已取消({{ subApplyActivity.canceledNum }})</el-radio-button
          >
        </el-radio-group>
      </div>
      <el-table
        stripe
        border
        :data="subApplyActivity.applyList.records"
        style="width: 100%"
        id="table"
        ref="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderSn"
          label="订单号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realName"
          label="用户名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="报名时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="联系方式"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="收费模式"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.actCostIntegral"
              >{{ scope.row.actCostIntegral }}积分</span
            >
            <span v-if="scope.row.actCostMoney"
              >{{ scope.row.actCostMoney }}元</span
            >
            <span
              v-if="!scope.row.actCostIntegral && !scope.row.actCostIntegral"
              >免费</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="authCode"
          label="核销码"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="actSite"
          label="活动地址"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="actRound"
          label="活动场次"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderStatus"
          label="订单状态"
        >
          <template slot-scope="scope">
            <div class="status danger" v-show="scope.row.orderStatus == 2"
              >已取消
              <div v-if="scope.row.oaMemo" class="danger" @click="showDialogOfflineOrderRefund(scope.row)">线下退款</div>
              </div
            >
            <span class="status success" v-show="scope.row.orderStatus == 1"
              >已报名</span
            >
            <span class="status success" v-show="scope.row.orderStatus == 3"
              >已完成</span
            >
            <span
              class="status success"
              v-show="
                scope.row.orderStatus != 1 &&
                  scope.row.orderStatus != 2 &&
                  scope.row.orderStatus != 3
              "
              >未支付</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="chargeStatus"
          label="核销状态"
        >
          <template slot-scope="scope">
            <span class="status danger" v-show="scope.row.chargeStatus == 1"
              >已核销</span
            >
            <span class="status success" v-show="scope.row.chargeStatus == 0"
              >未核销</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="chargeStatus"
          label="备注"
        >
          <template slot-scope="scope">
            {{scope.row.oaMemo?JSON.parse(scope.row.oaMemo).remark:''}}
          </template>
        </el-table-column>
        <!-- 未查询到该门店对应的组织机构，无法转到对应的供货商审批! -->
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
              <el-button
                class="mr10"
                size="small"
                type="text"
                @click="viewDetails(scope.row)"            
                >申报详情</el-button
              >
              <el-tooltip class="item" content="查看报名详情" placement="top">
                <div class="pointer mr10" @click="toDetails(scope.row)">
                  <span class="hmicon icon-chakan blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip
                class="item mr10"
                content="核销"
                placement="top"
                v-if="scope.row.chargeStatus == 0"
              >
                <div class="pointer" @click="openWriteOff(scope.row)">
                  <span class="hmicon icon-xingzhuanggaizhang blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip
                class="item mr10"
                content="不核销"
                placement="top"
                v-if="scope.row.chargeStatus == 1"
              >
                <div class="pointer" @click="remove(scope.row, '不核销', 0)">
                  <span class="hmicon icon-xingzhuanggaizhang blue"></span>
                </div>
              </el-tooltip>
              <el-button
                size="small"
                type="text"
                @click="offlineOrderRefund(scope.row)"
                v-if="scope.row.orderStatus == 1 && (dateDiff(scope.row.createTime)>=diffDay)"              
                >线下退款</el-button
              >
              <!-- <el-tooltip
                  class="item mr10"
                  content="取消预约"
                  placement="top"
                  v-else-if="scope.row.chargeStatus == 0 && scope.row.orderStatus == 1"
              >
                <div class="pointer" @click="del(scope.row, '取消预约')">
                  <span class="hmicon icon-guanbi1"></span>
                </div>
              </el-tooltip> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="subApplyActivity.applyList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
     <el-dialog
      title="报名详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
    <el-table
        stripe
        border
        class="mb20"
        ref="brandTable"
        :data="detailsList"
        style="width: 100%"
        id="table"
        size="small"
        :show-header="false"
      >
        <el-table-column
          header-align="center"
          align="right"
          prop="columnName"
          show-overflow-tooltip
          label="v.columnName"
          width="200"
        >
        <template slot-scope="scope">
          {{scope.row.columnName}}:
        </template>
        
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="inputValue"
          show-overflow-tooltip
          label="v.columnName"
        >
          <template slot-scope="scope">
            <el-image
              style="width:100px; height:100px"
              :src="scope.row.inputValue"
              :preview-src-list="[scope.row.inputValue]"
              v-if="scope.row.columnType === 'picture'"
            >
            </el-image>
             <span v-else>{{scope.row.inputValue}}</span>
      　　</template>
        </el-table-column>

    </el-table>
     </el-dialog>
     <el-dialog
      title="更改线下已退款订单状态"
      :close-on-click-modal="false"
      :visible.sync="dialogOfflineOrderRefund"
    >
      <div class="mb10" v-if="!operateTimeOfflineOrderRefund">您要申请更改“订单号：{{receiptSnRow}}”的状态？</div>
      <div class="mb10 danger" v-if="!operateTimeOfflineOrderRefund">注意 当前的操作针对的是线上超过3个月的订单，线下已经申请退款需要修改线上订单状态(不涉及积分和优惠券退还)，请审核无误后上传线下已经退款的凭据，请勿随意操作！！</div>
      <el-form
        :model="ruleFormOfflineOrderRefund"
        :rules="rulesOfflineOrderRefundrules"
        ref="ruleFormOfflineOrderRefund"
        label-width="150px"
        class="demo-ruleForm"
      >
        <div>
          <el-form-item label="退款凭证:" prop="pic">
            <el-upload
              class="upload flex"
              ref="eluploadMainPic"
              :limit="1"
              drag
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :onSuccess="uploadMainPicSucc"
              :beforeUpload="beforeUpload"
              :onProgress="uploading"
              :show-file-list="uploadShow"
              v-if="!ruleFormOfflineOrderRefund.pic"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片拖到此处，或
                <em>点击上传</em>
              </div>
            </el-upload>
            <div class="priview" v-if="ruleFormOfflineOrderRefund.pic">
              <el-image
                class="image"
                :src="ruleFormOfflineOrderRefund.pic"
                alt="主图"
                :preview-src-list="[ruleFormOfflineOrderRefund.pic]"
                />
              <div class="opreat-wrapper flex item-center flex-center" v-if="!operateTimeOfflineOrderRefund">
                <el-button type="text" @click="handleRemove">删除</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item class="mb10" label="备注:" prop="remark">
            <el-input
              style="height:100%"
              class="remark-tarea"
              size="small"
              type="textarea"
              clearable
              placeholder="请输入商品备注"
              maxlength="128"
              v-model="ruleFormOfflineOrderRefund.remark"
              :disabled="disabledRemark"
            ></el-input>
          </el-form-item>
          <el-form-item class="mb10" label="操作时间:" prop="operateTime" v-if="operateTimeOfflineOrderRefund">
            <div>{{operateTimeOfflineOrderRefund}}</div>
          </el-form-item>
          <el-form-item class="mb10" label="操作人:" prop="operateName" v-if="operateNameOfflineOrderRefund">
            <div>{{operateNameOfflineOrderRefund}}</div>
          </el-form-item>
        </div>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitFormOfflineOrderRefund('ruleFormOfflineOrderRefund')" v-if="!operateTimeOfflineOrderRefund"
            >提交</el-button
          >
          <el-button size="small" @click="dialogOfflineOrderRefund = false"
            >取消</el-button
          >
        </div>
      </el-form>
    </el-dialog>
     <el-dialog
      title="申报详情"
      :close-on-click-modal="false"
      :visible.sync="dialogDeclaration"
      width='40%'
    >
    <el-row>
      <el-col :span="16">
        <el-form ref="form" :model="declarationData" label-width="120px">
            <el-form-item label="导购姓名：">
              <div>{{declarationData.guiderName}}</div>
            </el-form-item>
            <el-form-item label="导购电话：">
              <div>{{declarationData.subscribeApplyBo.memberMobile}}</div>
            </el-form-item>
            <el-form-item label="商户名称：">
              <div>{{declarationData.storeName}}</div>
            </el-form-item>
            <el-form-item label="活动名称：">
              <div>{{declarationData.subscribeApplyBo.actName}}</div>
            </el-form-item>
            <el-form-item label="申报单号：">
              <div>{{declarationData.subscribeApplyBo.orderSn}}</div>
            </el-form-item>
             <el-form-item label="申报日期：">
              <div>{{declarationData.subscribeApplyBo.createTime}}</div>
            </el-form-item>
            <el-form-item label="门店名称：">
              <div>{{declarationData.shopName}}</div>
            </el-form-item>
        </el-form>   
      </el-col>
      <el-col :span="8">
        <div v-if="declarationData.declareImg">
          <el-image
          class="imageDeclaration"
          :src="declarationData.declareImg"
          alt="主图"
          :preview-src-list="[declarationData.declareImg]"
          />  
        </div>
      </el-col>
    </el-row>
       <div class="schedule" v-if="auditProgressDatas && auditProgressDatas.length>0">
            <h2>审核进度</h2>
                <ul>
                <li v-for="(item,index) in auditProgressDatas" :key="index">
                  <h3 v-if="item.createTime != null">{{item.createTime}}</h3>
                  <h3 v-if="item.createTime == null"></h3>
                  <p v-if="item.decisionOutcome == 'transferOrder'">{{item.realname}} <span
                      style="padding-left: 20rpx;">发起转单</span></p>
                  <p v-if="item.decisionOutcome == 'wait'">{{item.realname}} <span
                      style="padding-left: 20rpx;">待处理</span></p>
                  <p v-if="item.decisionOutcome == 'refuseOrder'">{{item.realname}} <span
                      style="padding-left: 20rpx;">(已拒绝)</span></p>
                  <p v-if="item.decisionOutcome == 'passed'">{{item.realname}} <span
                      style="padding-left: 20rpx;">已通过</span></p>
                </li>
              </ul>
          </div>
            <!-- <div class="flex flex-center mt20">
          <el-button type="primary" size="small" @click="dialogOfflineOrderRefund = false">确定</el-button
          >
          <el-button size="small" @click="dialogOfflineOrderRefund = false"
            >取消</el-button
          >
        </div> -->
     </el-dialog>
    <!-- 预约活动核销选择门店弹框 -->
    <verify-shop-dialog
      ref="verifyShopDialogRef"
      :store-code="storeCode"
      @confirmed="onShopConfirmed"
      @fallback="onShopFallback"
    />
  </hm-content>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { getLoginUser } from "@/utils/auth";
import VerifyShopDialog from "@/components/VerifyShopDialog.vue";

export default {
  components: {
    VerifyShopDialog
  },
  data() {
    const patternListHeader = function(rule, val, callback) {
      if (!this.ruleFormOfflineOrderRefund.pic) {
        return callback(new Error("请上传退款凭证"));
      }
      callback();
    }.bind(this);
    return {
      detailsList: [],
      roundList: [],
      siteList: [],
      actSite: "",
      subRoundId: "",
      actName: "",
      dialogVisible: false,
      dialogDeclaration:false,
      declarationData:{
        guiderName:'',
        subscribeApplyBo:{
          memberMobile:'',
          actName:'',
          orderSn:'',
          createTime:''
        },
        shopName:'',
        storeName:'',
        declareImg:''
      },
      auditProgressDatas:[],
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "all",
      pageSize: 10,
      date: [],
      keyword: "",
      authCode: "",
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      auditState: "",
      isOutputing: false,
      chargeStatus: "",
      diffDay: 0,
      dialogOfflineOrderRefund: false,
      ruleFormOfflineOrderRefund: {
        pic: "",
        remark: "",
      },
      rulesOfflineOrderRefundrules: {
        pic: [
          {
            required: true,
            validator: patternListHeader,
            trigger: "blur"
          }
        ],
      },
      uploadShow: true,
      receiptSnRow: "",
      operateTimeOfflineOrderRefund: "",
      operateNameOfflineOrderRefund: "",
      disabledRemark: false,
      // 核销选择门店相关
      storeCode: "",
    };
  },
  created() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    this.actName = this.$route.query.actName;
    this.queryActivityDetails();
    this.getParamValueAllowNull();
  },
  mounted() {
    this.queryList();
  },
  computed: mapGetters([
    "subActivityDetails",
    "subApplyActivity",
    "subscrobeActListCount",
    "allSubApplyActivity"
  ]),
  watch: {
    subActivityDetails(val) {
      this.siteList = val.roundBo;
    },
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    },
    dateAndTime(val) {
      this.startDate = val ? moment(val[0]).format("YYYY-MM-DD HH:mm:ss") : "";
      this.endDate = val ? moment(val[1]).format("YYYY-MM-DD HH:mm:ss") : "";
    }
  },
  methods: {
    queryActivityDetails() {
      this.$store.dispatch("subActivityDetails", {
        id: this.$route.query.id
      });
    },
    selectAddress() {
      this.roundList = this.actSite
        ? this.siteList.find(p => p.actSite === this.actSite).subscribeRound
        : [];
      this.subRoundId = "";
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        // const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        // this.$store.dispatch('allColumnName', {subActId: this.$route.query.id}).then(res => {
        //   let formColumn = res.result
          this.queryAllList()
            .then(res => {
              if(res.code === '0') {
                this.$message.success("导出成功");
              }
              // console.log("res", res);
              // console.log('---formColumn--', formColumn);
              // const tHeader = [
              //   "订单号",
              //   "用户名",
              //   "联系方式",
              //   "报名时间",
              //   "收费模式",
              //   "核销码",
              //   "活动地址",
              //   "活动场次",
              //   "订单状态",
              //   "核销状态",
              //   // "表单信息"
              // ].concat(formColumn);
              // const filterVal = [
              //   "orderSn",
              //   "realName",
              //   "memberMobile",
              //   "createTime",
              //   "charge",
              //   "authCode",
              //   "actSite",
              //   "actRound",
              //   "isorderStatus",
              //   "ischargeStatus",
              //   // "formValues"
              // ].concat(formColumn);
              // const list = res.result.applyList.records;
              // list.forEach(item => {
              //   if (!item.actCostIntegral && !item.actCostMoney) {
              //     item.charge = "免费";
              //   } else if (item.actCostIntegral) {
              //     item.charge = item.actCostIntegral + "积分";
              //   } else if (item.actCostMoney) {
              //     item.charge = item.actCostMoney + "元";
              //   }
              //   if (item.orderStatus == "2") {
              //     item.isorderStatus = "已取消";
              //   } else if (item.orderStatus == "1") {
              //     item.isorderStatus = "已报名";
              //   } else if (item.orderStatus == "3") {
              //     item.isorderStatus = "已完成";
              //   }
              //   if (item.chargeStatus == "1") {
              //     item.ischargeStatus = "已核销";
              //   } else if (item.chargeStatus == "0") {
              //     item.ischargeStatus = "未核销";
              //   }
              //   if (item.formValues) {
              //     item.formValuesMap.forEach(v => {
              //       Object.keys(v).forEach(key => {
              //         item[key] = v[key]
              //       })
              //     })
              //   }
              // });
              // const data = this.formatJson(filterVal, list);
              // exportJsonToExcel(
              //   tHeader,
              //   data,
              //   "预约列表" + new Date().toLocaleString()
              // );
              // this.isOutputing = false;
            })
            .catch(() => {
              this.isOutputing = false;
            });
        // })

      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    async toDetails(row) {
      const { result } = await this.$store.dispatch(
        "queryDynamicFormInputRecord",
        {
          inputId: row.centerId,
          invokeId: row.subActId
        }
      );
      this.detailsList = result;
      this.dialogVisible = true;
    },
    // 打开核销门店选择弹框
    openWriteOff(row) {
      this.$refs.verifyShopDialogRef.openShop(row);
    },
    // 核销成功后刷新列表
    onShopConfirmed() {
      this.queryList();
    },
    // 未配置门店信息，走原核销流程
    onShopFallback(row) {
      this.remove(row, "要核销", 1);
    },
    remove(row, txt, status) {
      const userInfo = getLoginUser()
      console.log('---userInfo--', userInfo);
      this.$confirm(
        "确定" + txt + "此预约信息？注：请仔细确认会员信息",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.$store
            .dispatch("pasApplyComplete", {
              id: row.id,
              chargeStatus: status,
              updateBy: userInfo.realname
            })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.queryList();
              }
            });
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    del(row, txt) {
      this.$confirm(
          "确定" + txt + "此预约信息？注：请仔细确认会员信息",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
      )
          .then(() => {
            
// pasApplyComplete
            this.$store
                .dispatch("pasApplyCancel", {
                  id: row.id
                })
                .then(res => {
                  if (res.code === "0") {
                    this.$message({
                      message: " 操作成功",
                      type: "success"
                    });
                    this.queryList();
                  }
                });
          })
          .catch(err => {
            throw new Error(err);
          });
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    queryList() {

      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        actSite: this.actSite,
        subRoundId: this.subRoundId,
        timeStatus: this.timeStatus,
        subActId: this.$route.query.id,
        keyword: this.keyword
      };
      if(this.$route.query.supplierCode) {
        params.supplierCode = this.$route.query.supplierCode;
        // delete params.subActId
      }
      if (this.date) {
        params.queryStartTime =
            this.date && this.date.length > 0 ? this.date[0] : null;
        params.queryEndTime =
            this.date && this.date.length > 0 ? this.date[1] : null;
      }

      return this.$store.dispatch("subApplyActivity", params);
    },
    queryAllList() {
      return this.$store.dispatch("getSubscribeApplyDetailListExport", {
        pageSize: 999999,
        pageNo: 1,
        actSite: this.actSite,
        queryEndTime: this.date && this.date.length > 0 ? this.date[1] : null,
        queryStartTime: this.date && this.date.length > 0 ? this.date[0] : null,
        subRoundId: this.subRoundId,
        timeStatus: this.timeStatus,
        subActId: this.$route.query.id,
        keyword: this.keyword,
        exportType: "yes",
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    clickImg(img) {
        console.log("图片放大");
				
			},
    async getParamValueAllowNull() {
      console.log("getParamValueAllowNull");
      const { code ,result } = await this.$store.dispatch("getParamValueAllowNull", {
        paramCode: "pas_subscribe_apply_refund_overdue_days"
      })
      if (code === "0") {
        console.log("result.paramValue",result.paramValue);
        this.diffDay = result.paramValue;
      }
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
      this.uploadShow = true;
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 1M!",
          type: "warning"
        });
      }
      return (extension || extension2 || extension3 || extension4) && limitSize;
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.ruleFormOfflineOrderRefund.pic = jsonData.result;
        this.uploadShow = false;
      }
    },
    // 移除上传文件
    handleRemove() {
      this.ruleFormOfflineOrderRefund.pic = "";
    },
    dateDiff(setDay) {
      //sDate1和sDate2是2006-12-18格式
      let aDate, oDate1, oDate2, iDays;
      aDate = setDay.split(" ")[0].split("-"); //调用Date的构造函数，转换为12-18-2006格式
      oDate1 = new Date(aDate[0], aDate[1] - 1, aDate[2]);
      let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      };
      if (date.month >= 1 && date.month <= 9) {
        date.month = "0" + date.month;
      }
      if (date.date >= 0 && date.date <= 9) {
        date.date = "0" + date.date;
      }
      oDate2 = oDate2 = new Date(date.year, date.month - 1, date.date); //把相差的毫秒数转换为天数
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24);
      return iDays;
    },
    offlineOrderRefund(v) {
      this.receiptSnRow = v.orderSn;
      this.ruleFormOfflineOrderRefund.pic = "";
      this.ruleFormOfflineOrderRefund.remark = "";
      this.operateNameOfflineOrderRefund = "";
      this.operateTimeOfflineOrderRefund = "";
      this.disabledRemark = false;
      this.dialogOfflineOrderRefund = true;
    },
    // 提交
    async submitFormOfflineOrderRefund(formName){
          const result = await this.$confirm(
            "请核实当前的订单是否正确，您是否上传了线下退款凭证，确认无误后再操作！",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          );
          if (result === "confirm") {
            this.$refs[formName].validate(valid => {
            if (valid) {
              let params = {
                orderSn: this.receiptSnRow,
                pic: this.ruleFormOfflineOrderRefund.pic,
                remark: this.ruleFormOfflineOrderRefund.remark,
              }
              console.log("params:",params);
              // return false;
              this.$store.dispatch("overdueApplyRefundUpdateOAOperateResult",params).then(res => {
                if (res.code === "0") {
                  this.$message({
                    message: "操作成功",
                    type: "success"
                  });
                  this.dialogOfflineOrderRefund = false;
                  this.queryList();
                }
              });
            }
          })
      }
    },
    showDialogOfflineOrderRefund(row){
      this.receiptSnRow = row.orderSn;
      this.ruleFormOfflineOrderRefund = JSON.parse(row.oaMemo);
      console.log("this.ruleFormOfflineOrderRefund:",this.ruleFormOfflineOrderRefund);
      this.operateNameOfflineOrderRefund = this.ruleFormOfflineOrderRefund.operatorUsername;
      this.operateTimeOfflineOrderRefund = this.ruleFormOfflineOrderRefund.operateTime;
      this.disabledRemark = true;
      this.dialogOfflineOrderRefund = true;
    },
     viewDetails(row) {
      console.log(row,8888888)
       this.declarationData = {
        guiderName:'',
        subscribeApplyBo:{
          memberMobile:'',
          actName:'',
          orderSn:'',
          createTime:''
        },
        shopName:'',
        storeName:'',
        declareImg:''
      },
         this.$store
        .dispatch("queryApplyDetails", {
          id: row.id,
        }).then((res) => {
          let { code, result } = res;
            if (code == 0) {
              this.declarationData = result;
              this.declarationData.declareImg = result.pasApplyStruct.declareImg.declareImg;
            }
        });
       this.auditProgress(row.id) 
      this.dialogDeclaration = true
   
    },
    auditProgress(id) {
      console.log(this.receiptId);
      this.$store
        .dispatch("queryEmployeeInfoAuditStepByList", {
          // receiptId: this.$route.query.receiptId,
          receiptId: id,
        })
        .then((res) => {
          let { code, result } = res;
          if (code == 0) {
            this.auditProgressDatas = result;
          }
        });
    },
  }
};
</script>

<style scoped lang="scss">
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}
.activity-name {
  font-size: 14px;
  color: #e50065;
}
.priview {
  position: relative;
  width: 360px;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  .image {
    width: 100%;
    height: 100%;
  }
  .video {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.imageDeclaration {
  height: 400px;
}
.schedule {
  h2 {
    height: 22px;
    font-family: PingFang HK, PingFang HK;
    font-size: 16px;
    color: #222222;
    line-height: 19px;
    text-align: left;
    position: relative;
    padding-left: 8px;
  }
  h2::before {
    content: "";
    width: 3px;
    height: 14px;
    background: #e50065;
    border-radius: 2px 0px 2px 0px;
    position: absolute;
    left: 0;
    top: 2px;
  }
  ul {
    li {
      min-height: 66px;
      position: relative;
      padding-left: 16px;
      h3 {
        height: 24px;
        font-family: PingFang SC, PingFang SC;
        font-size: 16px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.9);
        line-height: 24px;
        text-align: left;
      }
      p {
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.6);
        line-height: 22px;
        text-align: left;
        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #e50065;
          line-height: 22px;
          text-align: left;
          margin-right: 20px;
        }
      }
    }
    li:before {
      content: "";
      width: 8px;
      height: 8px;
      border-radius: 100px 100px 100px 100px;
      border: 2px solid #e50065;
      position: absolute;
      left: 0;
      top: 7px;
    }
    li:after {
      content: "";
      width: 4px;
      height: 40px;
      display: block;
      background: #dcdcdc;
      position: absolute;
      left: 3px;
      bottom: 0;
    }
  }
}
</style>
